import { render } from "./NewsPreview.vue?vue&type=template&id=d45880b0&scoped=true"
import script from "./NewsPreview.vue?vue&type=script&lang=js"
export * from "./NewsPreview.vue?vue&type=script&lang=js"

import "./NewsPreview.vue?vue&type=style&index=0&id=d45880b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d45880b0"]])

export default __exports__